<template>
  <div>
    <div class="container-fluid" :style="GatImg()">
      <nav v-if="this.$session.get('MenuLog') != null && this.$session.get('MenuLog').length && this.$session.get('MenuLog').length > 0" class="navbar navbar-expand-lg navbar-dark w-100" dir="rtl">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarText">
          <ul class="navbar-nav">
            <li class="nav-item" v-for="item in this.$session.get('MenuLog')" :key="item.id">
              <a
                :title="item.routeName == 'DepositPay' ? ' واریز به حساب / پرداخت اقساط از طریق شماره حساب / تسهیلات یا شناسه واریز بدون ورود به سامانه' : ' درخواست افتتاح حساب به صورت غیر حضوری و توسط پرتال'"
                class="nav-link text-right"
                href="javascript:void(0)"
                @click="GotoDeposit(item)"
                style="color: #ffffff !important"
                ><i class="ml-2" :class="item.menuIcone"></i>{{ item.name }}</a
              >
            </li>
          </ul>
        </div>
      </nav>

      <div class="row text-center">
        <div class="col-1 col-lg-2"></div>
        <div class="col-12 mt-md-0 mt-5 col-lg-8">
          <div class="card mt-5 center bg-light">
            <div class="card-body" style="padding: 20px !important; overflow: hidden">
              <div class="text-center mb-4">
                <h4 class="text-dark">پرسش های متداول</h4>
              </div>
              
              <div v-if="isLoading" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">در حال بارگذاری...</span>
                </div>
                <p class="text-muted mt-2">در حال بارگذاری پرسش‌های متداول...</p>
              </div>
              
              <div v-else-if="faqList.length === 0" class="text-center py-4">
                <p class="text-muted">اطلاعاتی وجود ندارد</p>
              </div>
              
              <div v-else class="accordion" id="faqAccordion" dir="rtl">
                <div v-for="(faq, index) in faqList" :key="faq.id || index" class="card mb-2" style="border: none; box-shadow: none;">
                  <div class="card-header p-0 font-weight-bold" :id="'heading' + index" style="background-color: transparent; border: none;">
                    <button
                      class="btn btn-link text-right w-100 text-dark p-3"
                      :class="{ 'collapsed': !expandedItems[index] }"
                      type="button"
                      @click="toggleCollapse(index)"
                      style="text-decoration: none; font-weight: 500;"
                    >
                      <i class="fas fa-question-circle ml-2" style="color: #7904d9; font-weight: bold;"></i>
                      <span style="font-weight: 700; font-size: 1.1em;">{{ faq.question }}</span>
                      <i class="fas float-left mt-1" :class="expandedItems[index] ? 'fa-chevron-up' : 'fa-chevron-down'" style="font-size: 12px;"></i>
                    </button>
                  </div>
                  <div
                    :id="'collapse' + index"
                    class="collapse"
                    :class="{ show: expandedItems[index] }"
                    :aria-labelledby="'heading' + index"
                  >
                    <div class="card-body text-right text-dark" style="padding: 15px 20px; font-weight: normal;">
                      {{ faq.answer }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-4 text-center">
                <router-link :to="{ name: 'LoginPage' }" style="text-decoration: none; color: #7904d9">
                  <i class="fas fa-arrow-right ml-2"></i>بازگشت به صفحه ورود
                </router-link>
              </div>
            </div>
            <div class="card-footer text-muted p-2">
              <div class="fas fa-server text-right" style="font-size: 10px !important">  Version : {{ $store.state.VersionSoftware }} </div>
            </div>
          </div>
        </div>
        <div class="col-1 col-lg-2"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appsettings: {},
      expandedItems: {},
      faqList: [],
      isLoading: true,
    }
  },
  methods: {
    GatImg() {
      return 'background-image:url("./Image/back.jpg");background-size: cover; height: 100vh;'
    },
    GotoDeposit(menuItem) {
      this.$router.push({
        name: menuItem.routeName,
      })
    },
    toggleCollapse(index) {
      if (this.expandedItems[index]) {
        this.$set(this.expandedItems, index, false)
      } else {
        Object.keys(this.expandedItems).forEach(key => {
          this.$set(this.expandedItems, key, false)
        })
        this.$set(this.expandedItems, index, true)
      }
    },
    getFAQData() {
      var axios = require('axios')
      var config = {
        method: 'GET',
        url: this.$GetapiBase() + 'FAQ/Get',
        headers: {
          'Content-Type': 'application/json',
        },
      }
      
      axios(config)
        .then((response) => {
          if (response.data && response.data.status === 'Ok' && response.data.result && Array.isArray(response.data.result)) {
            this.faqList = response.data.result.filter(item => item.isDeleted === false)
            
            if (this.faqList.length > 0) {
              this.$set(this.expandedItems, 0, true)
            }
          } else {
            this.faqList = []
          }
        })
        .catch((error) => {
          console.error('Error fetching FAQ data:', error)
          this.faqList = []
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
  created() {
    var axios = require('axios')
    var config = {
      method: 'GET',
      url: '/appSettings.json?nocache=' + Date.now(),
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
      },
    }
    axios(config).then((result) => {
      this.appsettings = result.data
    }).catch((error) => {
      console.error('Error loading appSettings in FAQ:', error)
    })
  },
  mounted() {
    let bootstrap = document.createElement('script')
    bootstrap.setAttribute('src', '/Template/NewMenu/js/bootstrap.bundle.js')
    if (!document.querySelector('script[src="/Template/NewMenu/js/bootstrap.bundle.js"]')) {
      document.head.appendChild(bootstrap)
    }
    
    this.getFAQData()
  }
}
</script>

<style scoped>
.container-fluid a,
p,
b,
h4 {
  font-size: 14px !important;
}

.navbar-dark {
  background-color: #6c519da6 !important;
}

.navbar-nav:hover {
  background-color: none !important;
}

.navbar-nav {
  background-color: none !important;
}

.center {
  -webkit-box-shadow: 5px 11px 21px 5px rgba(0, 0, 0, 0.58);
  box-shadow: 5px 11px 21px 5px rgba(0, 0, 0, 0.58);
  border: solid black;
  border-radius: 15px;
  overflow: hidden;
}

.card-header button {
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.3s;
}

.card-header button:hover {
  background-color: #f5f5f5;
}

.card-header button:focus {
  box-shadow: none;
  outline: none;
}

.collapse.show {
  border-bottom: 1px solid #e0e0e0;
}

@media (max-width: 767.98px) {
  .center {
    margin: 20px 10px;
  }
  
  .card-body {
    padding: 15px !important;
  }
}
</style>

